<template>
    <div style="background:#fff;height:91vh;overflow-y:auto; ">
        <div style="background:#fff;font-size:20px;font-weight:700;color:#409d8f;line-height:40px;text-align:center;width:100%">
            {{docObj['FILETYNM']}}：{{docObj['TITLE']}}
        </div>
        <div style="line-height:35px;height:35px;background:#808695;color:#fff;font-size:12px;padding-left:3px">
            <i class="iconfont icon-xuanze1" style="margin-right:5px"></i> 文档描述
        </div>
        <div v-html="v_html" style="margin-top:4px;line-height:25px;font-size:12px;padding-left:5px;background:#fff;"></div>
        <div style="margin-top:5px;line-height:35px;height:35px;background:#808695;color:#fff;font-size:12px;padding-left:3px">
            <i class="iconfont icon-xuanze1" style="margin-right:5px"></i> 文档附件
        </div>
        <div style="display:flex;margin-left:10px;flex-wrap:wrap;margin-top:8px"  >
            <div v-if="FILEPATH" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:30px;">  
                <div v-if="FILEPATH &&FILEPATH.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else fit="fill"  style="width:350px;height:325px;" :src="FILEPATH"> </el-image>
                <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                    <div class="menuitem">{{NAME1}}</div>
                    <div style="float:right;width:50px">
                        <el-link :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                    </div>
                </div>
            </div>
            <div v-if="FILEPATH2" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:30px;"> 
                <div v-if="FILEPATH2 &&FILEPATH2.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div> 
                <el-image v-else fit="fill"  style="width:350px;height:325px;" :src="FILEPATH2"> </el-image>
                <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                    <div class="menuitem">{{NAME2}}</div>
                    <div style="float:right;width:50px">
                        <el-link :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> 预览</el-link>
                    </div>
                </div>
            </div>

            <div v-if="FILEPATH3" style="border:1px solid #ccc;height:350px ;width:350px;margin-right:10px;">  
                <div v-if="FILEPATH3 &&FILEPATH3.indexOf('.pdf')>-1" style="width:350px;height:325px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div> 
                <el-image v-else fit="fill"  style="width:350px;height:325px;" :src="FILEPATH3"></el-image>
                <div style="line-height:25px;height:25px;background:#e8eaec;width:350px; display:flex;justify-content:space-between">
                    <div class="menuitem">{{NAME3}}</div>
                    <div style="float:right;width:50px">
                        <el-link :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> 预览</el-link>
                    </div>
                </div>
            </div>
        </div> 
        <!-- 预览图片 -->
        <el-dialog v-dialogDrag :visible.sync="showViewer" :width="tabWidth" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <el-image fit="scale-down"  :style="{'margin':'5px auto',height:imgHeight, 'width':'100% '}" :src="listurl"></el-image>
        </el-dialog>
    </div>
</template>

<script>
    import { getTabColOrData,getBaseData } from '../../api/user';
 
    export default {
        name: "document_detail",
        data(){
            return {
                v_html:'',
                v_idseq:'',
                v_lstseq:'',
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
                docObj:{},
                FILEPATH:'',
                FILEPATH2:'',
                FILEPATH3:'',
                showViewer:false,
                listurl:'',
                NAME1:'',
                NAME2:'',
                NAME3:'',
            }
        },
        created(){
            if (this.v_username){ 
                this.v_idseq=this.$route.query.p_idseq 
                this.v_lstseq=this.$route.query.p_lstseq 
                //初始化
                this.getData(); //树形数据
 
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        mounted(){
            getTabColOrData(this.v_url,'V_hr_docitm','idseq',this.v_idseq,'lstseq',this.v_lstseq,'','','').then((res) => {
                if (res.result.length>0 ){
                    this.docObj =res.result[0]
                }else{
                    this.docObj ={}
                }
            })
            this.getNoteList()
        },
        computed:{
            tabWidth(){
                return (window.innerWidth-160) + 'px'
            } ,
            imgHeight: function() {
                return (window.innerHeight - 140) + 'px';
            },
        },
        watch:{
 
        },
                                     
        methods:{
            getNoteList(){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getClobData',
                    data: {p_key:'idseq',p_value:this.v_idseq,p_key2:'lstseq',p_value2:this.v_lstseq, p_table:'V_HR_DOCLOB' },
                }).then(res=>{ 
                    this.v_html =res.result[0].note  
                    this.FILEPATH =res.result[0].path1    
                    this.FILEPATH2 =res.result[0].path2
                    this.FILEPATH3 =res.result[0].path3     
                    this.NAME1 =res.result[0].name1
                    this.NAME2 =res.result[0].name2
                    this.NAME3 =res.result[0].name3
                })
            },
            //图片预览
            imgPreview(path){
                if (path &&path.indexOf('.pdf')>-1){
                    let routeUrl = this.$router.resolve({
                        path: '/fullPreview',
                        query: {fileUrl: path},
                    });
                    window.open(routeUrl.href, '_blank');
                }else{
                    this.showViewer=true
                    this.listurl=path
                }
            },
        }
    }
</script>
<style lang="less" scoped>
   .menuitem {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    padding-left:2px;
    width:290px;
  }
</style>
<style lang="less">
 
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>

